import React from 'react';

import { useDragonBallTakeoverExposureEligibility } from 'features/app-takeover/hooks/use-app-takeover';
import { MenuTabsWrap } from 'features/menu/components/menu-tabs';
import { MainMenuPage } from 'features/menu/pages/main-menu-page';
import { MainMenuPageV2 } from 'features/menu/pages/main-menu-page-v2';
import { useStoreRequired } from 'features/store/hooks/use-store-required';

import { useDragonBallExperiment } from 'experiments/use-dragon-ball-experiment';
import { useEnableUnifiedMenu } from 'hooks/use-enable-unified-menu';
import { useMainMenuContext } from 'state/menu/main-menu';
import { routes } from 'utils/routing';

export default function MenuRoute() {
  useStoreRequired(true, undefined, routes.menu);

  return <MenuInner />;
}

const MenuInner = React.memo(() => {
  const enableUnifiedMenu = useEnableUnifiedMenu();
  const { isActive: isDragonBallTakeoverActive } = useDragonBallTakeoverExposureEligibility();
  const { activeDayParts } = useMainMenuContext();

  useDragonBallExperiment(!isDragonBallTakeoverActive, activeDayParts);

  return <MenuTabsWrap>{enableUnifiedMenu ? <MainMenuPageV2 /> : <MainMenuPage />}</MenuTabsWrap>;
});
